module.exports = __webpack_public_path__ + "media/images/file-icons/512/003-interface-bba42c9a976c1fb2be9f7e9813599eb2.png";